<template>
  <div class="content-box fr-ac-jsb">
    <img src="@/assets/images/logo.png" alt="" />
    <div class="province" @click="toOpen(userInfo.sf)" ref="province">
      <i class="el-icon-location"></i>
      {{ userInfo.sf }}
    </div>
    <div class="header-list">
      <div v-for="(item, ind) in list" :key="ind" @click="toPath(item)">
        {{ item.title }}
      </div>
    </div>
    <div class="fr-ac userInfo">
      <!-- <div class="mr-20 pointer" @click="toIndex">首页</div> -->
      <div
        class="fr-ac mr-20"
        :class="isIndex ? 'pointer' : ''"
        @click="showPopup()"
        v-if="isShow"
      >
        <div>
          <span>{{ userInfo.sf || "选择省份" }}</span>
          {{ userInfo.first_subject
          }}{{ userInfo.second_subject ? "," + userInfo.second_subject : "" }}
          {{ userInfo.fs == 0 || userInfo.fs ? userInfo.fs + "分" : "--分" }}
          {{ userInfo.pm ? userInfo.pm + "名" : "--名" }}
        </div>
      </div>
      <el-popover placement="bottom" width="200" trigger="click">
        <div class="pointer mb-10" @click="edit">身份信息</div>
        <div class="pointer" @click="exit()">退出</div>
        <img slot="reference" class="logo" :src="userInfo?.head_image" alt="" />
      </el-popover>
    </div>
    <DialogView
      :dialogList="dialogList"
      v-if="dialogList.isTrue"
      @remove="remove"
      @save="save"
      @userEdit="userEdit"
      @getEdit="getEdit"
      @userSeve="userSeve"
    ></DialogView>
  </div>
</template>

<script>
import store from "../store";
import { mapState } from "vuex";

export default {
  name: "topFixed",
  props: {
    userInfo: Object,
    isIndex: Boolean,
    isShow: Boolean,
  },
  computed: {
    // ...mapState({
    //   homepage: (state) => state.user.homepage,
    // }),
  },
  watch: {
    userInfo: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.homepage();
        }
      },
    },
  },
  data() {
    return {
      // userInfo: {}
      list: [
        {
          title: "首页",
          path: "/fill/fill_home",
          is_open: true,
          is_vip: true,
        },
        {
          title: "查大学",
          path: "/fill/fill_school",
          is_open: false,
          is_vip: false,
        },
        {
          title: "查专业",
          path: "/fill/fill_speciality",
          is_open: false,
          is_vip: false,
        },
        {
          title: "选科系统",
          path: "/fill/fill_optional",
          is_open: false,
          is_vip: true,
        },
        {
          title: "模拟填报",
          path: "/fill/fill_index",
          is_open: false,
          is_vip: false,
        },
      ],
      dialogList: {
        isTrue: false,
      },
      getUserAuthInfo: {},
      homePage: {},
    };
  },
  methods: {
    toIndex() {
      this.$router.push({ path: "/fill/fill_home" });
    },
    exit() {
      localStorage.clear(); //清除本地缓存
      this.$store.commit("CLEARDATA"); //清除vuex数据
      location.reload();
    },
    showPopup() {
      if (this.isIndex) {
        this.$emit("showPopup");
      }
    },
    async edit() {
      const res = await this.$http.fetch("api/user/getUserAuthInfo", {});
      if (res.status === 200) {
        this.getUserAuthInfo = res.data;
        this.dialogList = {
          type: "A",
          isTrue: true,
          province: "",
          remove: true,
          crowd:
            res.data.crowd === 1 ? "学生" : res.data.crowd === 2 ? "家长" : "",
          candidates_identity: res.data.candidates_identity,
          graduation: res.data.graduation,
          school_city: res.data.school_city,
          school_province: res.data.school_province,
          school_type: res.data.school_type,
          middle_school: res.data.middle_school,
          disabled: true,
          title: "身份信息",
        };
      }
    },
    // 跳转到指定路径
    toPath(item) {
      if (item.is_open) {
        if (item.is_vip) {
          this.$router.push(item.path);
        } else {
          if (item.title === "查大学" || item.title === "查专业") {
            this.dialogList = {
              type: "C",
              title: "您暂未开通【五查系统】功能，开通系统即可体验",
              isTrue: true,
              button: "开通",
              province: this.userInfo.sf,
            };
          }
          if (item.title === "模拟填报") {
            this.dialogList = {
              type: "C",
              title: "您暂未开通【模拟填报】功能，开通系统即可体验",
              isTrue: true,
              button: "开通",
            };
          }
        }
      } else {
        if (item.title === "查大学" || item.title === "查专业") {
          this.dialogList = {
            type: "C",
            title: "当前省份未开放【五查系统】功能，敬请期待！",
            isTrue: true,
            button: "确定",
          };
        }
        if (item.title === "模拟填报") {
          this.dialogList = {
            type: "C",
            title: "当前省份未开放【模拟填报】功能，敬请期待！",
            isTrue: true,
            button: "确定",
          };
        }
        if (item.title === "选科系统") {
          this.dialogList = {
            type: "C",
            title: "当前省份未开放【选科系统】功能，敬请期待！",
            isTrue: true,
            button: "确定",
          };
        }
      }
    },
    toOpen(val) {
      if (this.userInfo.isWhite && this.$route.path === "/fill/fill_home") {
        this.dialogList = {
          type: "B",
          isTrue: true,
          province: val,
        };
      }
    },
    remove() {
      this.dialogList.isTrue = false;
    },
    async save(val) {
      if (this.$route.path === "/fill/fill_home") {
        const res = await this.$http.fetch("api/user/changeProvince", {
          province: val,
        });
        if (res.status === 200) {
          this.dialogList.isTrue = false;
          const res = await this.$http.fetch("/api/login/getUserInfo", {});
          if (res.status === 200) {
            this.$store.dispatch("user/setUserInfo", res.data);
            this.$emit("fixedSave", res.data);
          }
        }
      }
    },
    userEdit() {
      this.dialogList = {
        type: "A",
        isTrue: true,
        title: "完善信息",
        remove: false,
        save: false,
        disabledEdit: true,
      };
    },
    getEdit(val) {
      val.isTrue = true;
      val.province = "";
      val.remove = true;
      val.crowd =
        this.getUserAuthInfo.crowd === 1
          ? "学生"
          : this.getUserAuthInfo.crowd === 2
          ? "家长"
          : "";
      val.candidates_identity = this.getUserAuthInfo.candidates_identity;
      val.graduation = this.getUserAuthInfo.graduation;
      val.school_city = this.getUserAuthInfo.school_city;
      val.school_province = this.getUserAuthInfo.school_province;
      val.school_type = this.getUserAuthInfo.school_type;
      val.middle_school = this.getUserAuthInfo.middle_school;
      val.disabled = true;
      val.title = "身份信息";
    },
    async userSeve(val) {
      const res = await this.$http.fetch("/api/user/completeUserInfo", val);
      if (res.status === 200) {
        this.dialogList.isTrue = false;
        const res = await this.$http.fetch("/api/login/getUserInfo", {});
        if (res.status === 200) {
          this.$store.dispatch("user/setUserInfo", res.data);
          this.$emit("fixedSave", res.data);
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    async homepage() {
      const res = await this.$http.fetch("api/homepage/index", {
        sf: this.userInfo.sf,
      });
      if (res.status === 200) {
        this.$store.dispatch("user/setHomePage", res.data);
        this.list[1].is_open = res.data.wucha.is_open;
        this.list[1].is_vip = res.data.wucha.is_vip;
        this.list[2].is_open = res.data.wucha.is_open;
        this.list[2].is_vip = res.data.wucha.is_vip;
        this.list[3].is_open = res.data.xuanke.is_open;
        this.list[4].is_open = res.data.moni.is_open;
        this.list[4].is_vip = res.data.moni.is_vip;
      }
    },
  },
  mounted() {
    // this.userInfo = store.state.user.info
    // console.log(this.userInfo,"this.userInfo");
    const elementId = this.$refs.province;
    if (this.$route.path === "/fill/fill_home") {
      elementId.style.cursor = "pointer";
    }
    if (this.userInfo.sf) {
      this.homepage();
    }
    
  },
  created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.content-box {
  width: 100%;
  height: 55px;
  background-color: rgb(234, 234, 234);
  padding: 0 13%;
  position: sticky;
  top: 0;
  z-index: 2000;

  div {
    font-size: 16px;
    font-weight: 600;
  }
}
.province {
  margin-left: 5%;
}
.header-list {
  flex: 1;
  display: flex;
  align-items: center;
  margin-left: 3%;
  div {
    padding: 0 2%;
    cursor: pointer;
    &:hover {
      color: red;
    }
  }
}
.logo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.pointer:hover {
  color: #e84c33;
}
</style>
